// extracted by mini-css-extract-plugin
export default {"button":"OutlinedButton_button__ISoYR"};